let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7th2q")).then(() => parcelRequire('2Dq8O'));